import { useFormikContext } from 'formik';
import React, { FC, useEffect, useState } from 'react';
import Label from '../label/label';
import { CanGoNext } from "../../models/CanGoNext";
import Togglebox from '../togglebox/togglebox';
import { useLocale } from '../../contexts/localeContext';
import { TranslationKeys } from '../../contexts/TranslationKeys';
import { getCategoryFieldNames } from '../../services/customFieldsService';
import { SelectListField } from './SelectListField';
import { SettingTextField } from '../settingFields/SettingTextField';
import { requiredValidation } from '../../utilities/Validation';
import { useWizardSummaryContext } from '../wizard/wizardSummaryContext';
import { ButtonTypes } from '../../models/ButtonTypes';
import { DEF_PG_SIZE_DROP_DOWN_MIN } from '../../constants/maximum-page-size';

export interface DetailFields {
    displayName: string;
    description: string;
    copyOf: string;
    singleOwner: boolean;
    autoIdNumber: boolean;
}

interface DetailsFormProps extends CanGoNext {
    categoryId?: number;
    options?: any;
    setSideBarStepDescription?: (newDescription) => void;
    onDelete?: () => void;
    totalEnrolments?: number
}

const DetailsForm: FC<DetailsFormProps> = ({ onNext, categoryId = undefined, options = [], setSideBarStepDescription = () => { }, onDelete, totalEnrolments }) => {
    const { translate } = useLocale();
    const [categorySelected, setCategorySelected] = useState(false);
    const { setFieldValue, errors, values } = useFormikContext();
    const { updateSummary } = useWizardSummaryContext();
    const [hasError, setHasError] = useState(false);

    useEffect(() => {
        if (Object.keys(errors as any).length > 0) {
            setHasError(true)
        }
        else {
            setHasError(false)
        }
    }, [errors])

    const handleCategorySelection = (item) => {
        // set the form value selection to the profile fields for the selected profile.
        if (item) {
            updateSummary("copyOfName", item.label);
            getCategoryFieldNames(item.value)
                .then(categoryFieldNames => {
                    setFieldValue("fields", categoryFieldNames.map(categoryFieldName => categoryFieldName.value));
                });
        }
    }

    const handleSelection = item => {
        setCategorySelected(true);
        handleCategorySelection(item);
    }

    return <div className="pt-3 pr-3 h-full relative">
        <div className="flex flex-col ">
            <SettingTextField
                accessor={'displayName'}
                required validation={(value) => requiredValidation(value, translate)}
                isCard
                displayName={translate.byKey(TranslationKeys.displayName)}></SettingTextField>
            <SettingTextField
                accessor={'description'}
                multiLine
                isCard
                displayName={translate.byKey(TranslationKeys.description)}></SettingTextField>
            {/* <div className="pb-3">
            </div>
            <div className="pb-3">
            </div>
            <div className="pb-3">
            </div> */}
            {categoryId === undefined
                ? <>
                    <Label htmlFor="copyOf"
                        className="text-xs text-gray-600 mt-1"
                        required>{translate.byKey(TranslationKeys.copyOf)}:</Label>
                    <SelectListField
                        accessor="copyOf"
                        options={options}
                        onSelect={handleSelection}
                        pageSize={DEF_PG_SIZE_DROP_DOWN_MIN}>
                    </SelectListField>
                </>
                : null}
            {/* <div className="flex flex-col pb-3">
                <Label htmlFor="singleOwner"
                    className="text-sm text-gray-700 pb-1">{translate.byKey(TranslationKeys.singleOwner)}:</Label>
                <Togglebox name="singleOwner" label=''>
                </Togglebox>
            </div>
            <div className="flex flex-col pb-3">
                <Label htmlFor="autoIdNumber"
                    className="text-sm text-gray-700 pb-1">{translate.byKey(TranslationKeys.autoGenerateIdNumber)}:</Label>
                <Togglebox name="autoIdNumber" label=''>
                </Togglebox>
            </div> */}
        </div>
        <div className="flex flex-row justify-between absolute bottom-0 right-0 pr-3 pb-3 w-full">
            {categoryId
                ? <button type='button'
                    className={`py-1 px-5 ml-3 secondary ${onDelete && !!totalEnrolments === false ? 'warning' : 'secondary-disabled cursor-not-allowed'}`}
                    onClick={onDelete && !!totalEnrolments === false ? () => onDelete() : () => { }}
                    title={onDelete && !!totalEnrolments === false ? null : translate.byKey(TranslationKeys.relatedEnrolments)}>{translate.byKey(TranslationKeys.deleteCategory)}</button>
                : <span></span>}
            <button
                className={`secondary py-1 px-5 ${(categorySelected || categoryId) && !hasError ? 'secondary-enabled' : 'secondary-disabled cursor-not-allowed'}`}
                type="button"
                onClick={(categorySelected || categoryId) && onNext ? (e) => { if (!hasError) { onNext(e); setSideBarStepDescription((values as any)['displayName']); } } : () => { }}>{translate.byKey(TranslationKeys.next)}</button>
        </div>
    </div >;
}

export default DetailsForm;
